import _ from 'lodash';
import { ERRORS } from '../strings';

const isEmpty = (value) => value === undefined || value === null || value === '';
const join = (rules) => (value, data, params) =>
  rules.map((rule) => rule(value, data, params)).filter((error) => !!error)[0];

export function email(value) {
  // Let's not start a debate on email regex. This is just for an example app!
  if (!isEmpty(value) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    return 'Invalid email address';
  }
}

export function required(value) {
  if (isEmpty(value)) {
    return 'Required';
  }
}

export function minLength(min) {
  return (value) => {
    if (!isEmpty(value) && value.length < min) {
      return `Must be at least ${min} characters`;
    }
  };
}

export function maxLength(max) {
  return (value) => {
    if (!isEmpty(value) && value.length > max) {
      return `Must be no more than ${max} characters`;
    }
  };
}

export function exactLength(len) {
  return (value) => {
    if (!isEmpty(value) && value.length > len) {
      return `Must be exactly ${len} characters`;
    }
  };
}

export function integer(value) {
  if (!isEmpty(value) && !Number.isInteger(Number(value))) {
    return 'Must be an integer';
  }
}

export function money(value) {
  if (!isEmpty(value) && (!/^\d+(\.\d{2})?$/.test(value) || parseFloat(value) <= 0)) {
    return 'Must be a valid US currency value (more than 0.00).';
  }
}

export function oneOf(enumeration) {
  return (value) => {
    if (!~enumeration.indexOf(value)) {
      return `Must be one of: ${enumeration.join(', ')}`;
    }
  };
}

export function match(field) {
  return (value, data) => {
    if (data) {
      if (value !== data[field]) {
        return ERRORS.PASSWORDS_DO_NOT_MATCH;
      }
    }
  };
}

export function createValidator(rules, params) {
  return (data = {}) => {
    const errors = {};
    Object.keys(rules).forEach((key) => {
      const rule = join([].concat(rules[key])); // concat enables both functions and arrays of functions
      const error = rule(_.get(data, key), data, { key, ...params });
      if (error) {
        _.set(errors, key, error);
      }
    });
    return errors;
  };
}

export function ensureBankNameUnique(user, value) {
  if (!_.isEmpty(value) && !!_.find(_.get(user, 'savedAccounts'), { bankName: value })) {
    return 'There is already a saved account with this bank name, please choose another';
  }
}
